import { render, staticRenderFns } from "./ItemVedettStrand.vue?vue&type=template&id=c38f6f86&scoped=true&"
import script from "./ItemVedettStrand.vue?vue&type=script&lang=js&"
export * from "./ItemVedettStrand.vue?vue&type=script&lang=js&"
import style0 from "./ItemVedettStrand.vue?vue&type=style&index=0&id=c38f6f86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38f6f86",
  null
  
)

export default component.exports